module.exports = __webpack_public_path__ + "img/46.8899f7ac.jpg";